"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRequestInterceptor = exports.axios = void 0;
let _axios;
const getAxios = async () => {
    if (_axios == null) {
        const x = await Promise.resolve().then(() => __importStar(require('axios')));
        _axios = x.default;
    }
    return _axios;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const axios = async (request) => {
    const axios = await getAxios();
    return await axios(request);
};
exports.axios = axios;
const addRequestInterceptor = async (onFulfilled, onRejected) => {
    const axios = getAxios();
    return (await axios).interceptors.request.use(onFulfilled, onRejected);
};
exports.addRequestInterceptor = addRequestInterceptor;
